import React from 'react';
import { Section } from '../ui/Section';
import { Thermometer, Brain, Zap } from 'lucide-react';
export function MechanismSection() {
  return <Section background="navy" className="relative overflow-hidden" data-id="element-41">
      {/* Ambient amber glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[200px] bg-brand-amber/8 blur-[80px] pointer-events-none" data-id="element-42"></div>

      <div className="relative z-10" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <p className="text-brand-amber text-xs font-semibold uppercase tracking-[0.2em] mb-3" data-id="element-45">
            The Root Cause
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-cream mb-4" data-id="element-46">
            Introducing: The Deep Sleep Cortisol Reset
          </h2>
          <p className="text-brand-parchment text-lg max-w-2xl mx-auto" data-id="element-47">
            This isn't a book about "sleep hygiene." I won't tell you to buy
            $500 blackout curtains or meditate for an hour.
          </p>
        </div>

        <div className="bg-brand-amber/5 border border-brand-amber/20 rounded-2xl p-8 md:p-12 mb-12" data-id="element-48">
          <h3 className="text-2xl font-serif font-bold text-brand-amber mb-4 text-center" data-id="element-49">
            The 3-2-1 Thermal Protocol
          </h3>
          <p className="text-brand-parchment text-lg leading-relaxed text-center mb-10" data-id="element-50">
            A simple, biological sequence that forces your core temperature to
            drop and signals your nervous system to enter "Rest and Digest" mode
            instantly.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-51">
            {[{
            icon: <Thermometer className="h-8 w-8" data-id="element-52" />,
            title: 'Core Cooling',
            desc: 'Triggers the release of natural melatonin by dropping internal temp.'
          }, {
            icon: <Brain className="h-8 w-8" data-id="element-53" />,
            title: 'Cortisol Flush',
            desc: 'Stops the "fight or flight" response that keeps your brain active.'
          }, {
            icon: <Zap className="h-8 w-8" data-id="element-54" />,
            title: 'Deep Wave Sleep',
            desc: 'Enter restorative REM cycles faster and stay there longer.'
          }].map((item, i) => <div key={i} className="text-center" data-id="element-55">
                <div className="bg-brand-amber/10 border border-brand-amber/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-brand-amber" data-id="element-56">
                  {item.icon}
                </div>
                <h4 className="text-brand-cream font-bold mb-2" data-id="element-57">
                  {item.title}
                </h4>
                <p className="text-brand-muted text-sm" data-id="element-58">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}